import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { typography, colors } from '@resiliatech/birdsong'

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
`

export const ContentWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const StepContainer = styled(Box)<{ width?: number; height?: number }>`
  display: flex;
  width: ${({ width }) => (width ? `${width}px` : '1040px')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 6.428px;
  background: ${colors.background.secondaryBackground};
  box-shadow: 0px 14.462px 73.917px 12.855px rgba(0, 0, 0, 0.12),
    0px 38.566px 61.062px 4.821px rgba(0, 0, 0, 0.14),
    0px 17.676px 24.104px -11.248px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
`

export const HeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'shouldCenter',
})<{ shouldCenter?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  align-items: ${({ shouldCenter = false }) =>
    shouldCenter ? 'center' : 'flex-start'};
`

export const Header = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const HeaderTitleContainer = styled(Box)<{ shouldCenter?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  justify-content: ${({ shouldCenter = false }) =>
    shouldCenter ? 'center' : 'flex-start'};
`

export const HeaderTitle = styled(Typography)`
  ${typography.up1.regularSerif};
  color: ${colors.text.primary};
`

export const HeaderDescription = styled(Typography)`
  ${typography.baseline.regularSans};
  color: ${colors.text.primary};
`

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const WizardIcon = styled(AutoFixHighIcon)`
  color: ${colors.interactive.primaryEnabled};
  font-size: 24px;
  margin-top: 4px;
`
